import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, DetailsRow, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import '../../css/immocom.css';
import { DataIndicateur } from '../../data/DataIndicateur';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAnnee } from '../ComboBox/ComboBoxAnnee';
import { ComboBoxMois } from '../ComboBox/ComboBoxMois';
import { EUITextField } from '../EUI/EUITextField';
import { FicheDetailIndicateurValidation } from '../Fiche/FicheDetailIndicateurValidation';
import '../List/DetailsListCG.css';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

var objetState = {
    items: [],
    groupesOperations: [],
    selectedReservations: [],
    selectedReservation: {},
    labelPeriode: 'Période non ouverte',
    dateDebutPeriodeOuverte: null,

    enCoursDeTraitement: false,
    messageEnCoursDeTraitement: '',
    messageRetourValidation: '',

    onAffichePanelFiltre: false,
    onAffichePanelDetailIndicateur: false,

    onAfficheDialogValidationCG: false,
    onAfficheDialogAnnulationValidation: false,
    onAfficheDialogRetourValidation: false,

    onPeutChargerLeComposantFicheDetailIndicateurValidation: false,

    peutAccederSuiviBudgetaire: false,
    peutValider: false,

    //estValidee: false,

    filtreMois: 0,
    filtreAnnee: 0,
    filtreNumLot: null,
    filtreResaDesisNonValidees: true,
    filtreResaDesistValidees: false,

    pageIndex: 1,
    facteurNbreEnregistrement: 100,
    tri: "",

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    warningMessage: '',
    errorMessage: ''
};

export class DetailsListCGValidation extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListCGValidationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListCGValidationWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent() {
        const { items, groupesOperations } = this.state;

        return (!this.state.peutAccederSuiviBudgetaire ? null :
            <DetailsList
                setKey="items"
                items={items}
                groups={groupesOperations}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                onRenderRow={this._onRenderRow}
                selectionMode={SelectionMode.multiple}
                columns={this.columns}
                onColumnHeaderClick={this._onColumnHeaderClick}
                selection={this._selection}
            />
        );
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => this._onChangeSelection(),
            canSelectItem: this._onCanSelectItem
        });

        this.state = objetState;

        //#region chargement des columns
        let columnsTemp = [];

        columnsTemp.push({
            key: 'dateValidationCG',
            name: 'Date validation CG',
            ariaLabel: 'Date validation CG',
            fieldName: 'dateValidationCG',
            minWidth: 45,
            maxWidth: 120,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let dateValidationCG = (item.dateValidationCG !== null ? Scriba.date().stringDateFormatCourt(item.dateValidationCG) : '');
                return <span title={dateValidationCG} className={(dateValidationCG !== '' ? 'labelDateClotureRegionaleOuverte' : '')}>{dateValidationCG}</span>;
            }
        });
        columnsTemp.push({
            key: 'nomOperation',
            name: 'Opération',
            ariaLabel: 'Opération',
            fieldName: 'nomOperation',
            minWidth: 150,
            maxWidth: 300,
            isResizable: true,
            onRender: (item) => {
                return <span title={item.nomOperation} className={this._getClassNameDesistement(item.categorie)}>{item.nomOperation}</span>;
            }
        });
        columnsTemp.push({
            key: 'typeReservation',
            name: 'Type',
            ariaLabel: 'Type',
            fieldName: 'typeReservation',
            minWidth: 80,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.typeReservation} className={this._getClassNameDesistement(item.categorie)}>{item.typeReservation}</span>;
            }
        });
        columnsTemp.push({
            key: 'categorie',
            name: 'Catégorie',
            ariaLabel: 'Catégorie',
            fieldName: 'categorie',
            minWidth: 80,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span title={item.categorie} className={this._getClassNameDesistement(item.categorie)}>{item.categorie}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbResas',
            name: 'Nb lots',
            ariaLabel: 'Nb lots',
            fieldName: 'nbResas',
            minWidth: 25,
            maxWidth: 45,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let nbResas = item.nbResas;

                return <span title={nbResas} className={this._getClassNameDesistement(item.categorie)}>{nbResas}</span>;
            }
        });
        columnsTemp.push({
            key: 'numero',
            name: 'N° lot',
            ariaLabel: 'N° lot',
            fieldName: 'numero',
            minWidth: 30,
            maxWidth: 90,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let numLot = item.numero;

                return <span title={numLot} className={this._getClassNameDesistement(item.categorie)}>{numLot}</span>;
            }
        });
        columnsTemp.push({
            key: 'lotType',
            name: 'Nb pièces',
            ariaLabel: 'Nb pièces',
            fieldName: 'lotType',
            minWidth: 30,
            maxWidth: 100,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let nbPieces = item.lotType;

                return <span title={nbPieces} className={this._getClassNameDesistement(item.categorie)}>{nbPieces}</span>;
            }
        });
        columnsTemp.push({
            key: 'dateReservation',
            name: 'Date de réservation / désistement',
            ariaLabel: 'Date de réservation / désistement',
            fieldName: 'dateReservation',
            minWidth: 80,
            maxWidth: 150,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let dateReservation = (item.dateReservation !== null ? Scriba.date().stringDateFormatCourt(item.dateReservation) : '');
                return <span title={dateReservation} className={this._getClassNameDesistement(item.categorie)}>{dateReservation}</span>;
            }
        });
        columnsTemp.push({
            key: 'prixHTGrille',
            name: 'Prix grille HT (en €)',
            ariaLabel: 'Prix grille HT (en €)',
            fieldName: 'prixHTGrille',
            minWidth: 80,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prixHTGrille = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixHTGrille).toFixed(2), false, 2);

                return (item.prixHTGrille !== null ? <span title={`${prixHTGrille} €`} className={this._getClassNameDesistement(item.categorie)}>{`${prixHTGrille} €`}</span> : null);
            }
        });
        columnsTemp.push({
            key: 'prixHTResa',
            name: 'Prix réservation HT (en €)',
            ariaLabel: 'Prix réservation HT (en €)',
            fieldName: 'prixHTResa',
            minWidth: 80,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prixHTResa = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixHTResa).toFixed(2), false, 2);

                return (item.prixHTResa !== null ? <span title={`${prixHTResa} €`} className={this._getClassNameDesistement(item.categorie)}>{`${prixHTResa} €`}</span> : null);
            }
        });
        columnsTemp.push({
            key: 'validation',
            name: '',
            ariaLabel: 'Valider / Dévalider',
            fieldName: 'validation',
            minWidth: 40,
            maxWidth: 40,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return (this._onBloqueValidation(item) ? null : <Toggle
                    title="Valider / Dévalider"
                    checked={item.validationCG}
                    onText="Oui"
                    offText="Non"
                    onChange={(e, isChecked) => (isChecked ? this._onAffichageDialogValidation([item]) : this._onAffichageDialogAnnulation([item]))}
                />);
            }
        });
        columnsTemp.push({
            key: 'detailIndicateur',
            name: '',
            ariaLabel: 'Voir le détail',
            fieldName: 'detailIndicateur',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Search' }}
                    title="Voir le détail"
                    ariaLabel="Voir le détail"
                    onClick={() => this._onAffichePanelDetailIndicateur(item)}
                />;
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }

    _onChangeSelection = () => {
        this.setState({ selectedReservations: this._selection.getSelection() });
    }

    _onCanSelectItem = (item) => {
        return !this._onBloqueValidation(item);
    }

    _getItems = () => {
        let periodeOuverte = (this.state.labelPeriode !== 'Période non ouverte');
        let tableauBoutons = [];

        let boutonValider = {
            key: 'validerReservations',
            name: 'Valider les réservations sélectionnées',
            iconProps: {
                iconName: 'CheckMark'
            },
            onClick: (() => this._onAffichageDialogValidation(this.state.selectedReservations)),
            disabled: !periodeOuverte || this.state.selectedReservations.length === 0
        }

        tableauBoutons.push(boutonValider);

        let boutonAnnuler = {
            key: 'annulerValidation',
            name: 'Annuler la validation',
            iconProps: {
                iconName: 'Cancel'
            },
            onClick: (() => this._onAffichageDialogAnnulation(this.state.selectedReservations)),
            disabled: !periodeOuverte || this.state.selectedReservations.length === 0
        }

        tableauBoutons.push(boutonAnnuler);

        return tableauBoutons;
    }

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des indicateurs en cours'
        });

        let chargementListeDesINDICATEURSValidation = DataIndicateur._chargementListeDesINDICATEURSValidation(this.state.tri, this.state.filtreMois, this.state.filtreAnnee, this.state.filtreNumLot, this.state.filtreResaDesisNonValidees, this.state.filtreResaDesistValidees, this.state.facteurNbreEnregistrement, this.state.pageIndex);


        chargementListeDesINDICATEURSValidation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let new_Items = [];
                    let listeGroupesOperations = [];
                    let listeItem = (objetData[0] !== null ? objetData[0] : []);
                    let periodeOuverture = objetData[2];

                    if (this.state.pageIndex === 1) {
                        new_Items = listeItem;
                    }
                    else {
                        new_Items = this.state.items
                        new_Items = new_Items.concat(listeItem);
                    }

                    // Regroupement par opérations
                    if (new_Items.length > 0) {
                        let operationTrav = new_Items[0];
                        let idOperationTrav = operationTrav.idOperation;
                        let nomOperationTrav = operationTrav.nomOperation;
                        let nbOperations = 0;
                        let depart = 0;

                        new_Items.forEach(function (value, index) {
                            let idOperation = value.idOperation;

                            if (idOperation === idOperationTrav) {
                                nbOperations++;
                            }
                            else {
                                listeGroupesOperations.push({ key: idOperationTrav, name: nomOperationTrav, startIndex: depart, count: nbOperations });

                                operationTrav = value;
                                idOperationTrav = idOperation;
                                nomOperationTrav = value.nomOperation;
                                depart = (depart + nbOperations);
                                nbOperations = 1;
                            }

                            if (index === (new_Items.length - 1)) {
                                // Dernier de la liste
                                listeGroupesOperations.push({ key: idOperationTrav, name: nomOperationTrav, startIndex: depart, count: nbOperations });
                            }
                        });
                    }

                    this.setState({
                        items: new_Items,
                        groupesOperations: listeGroupesOperations,
                        labelPeriode: (periodeOuverture.mois !== null && periodeOuverture.annee !== null ? 'Période en cours : ' + periodeOuverture.mois + ' ' + periodeOuverture.annee : 'Période non ouverte'),
                        dateDebutPeriodeOuverte: periodeOuverture.dateDebut,

                        peutAccederSuiviBudgetaire: objetData[1],
                        peutValider: objetData[3],

                        enCoursDeTraitement: false,
                        messageEnCoursDeTraitement: '',

                        hideMessageBarWarning: true,
                        warningMessage: '',
                        hideMessageBarError: true,
                        errorMessage: ''
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.peutAccederSuiviBudgetaire = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _validationDevalidationCG = (onValide) => {
        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: `${onValide ? 'Validation' : 'Annulation'} en cours` });

        let _onEnregistrementValidationOuAnnulationCG = DataIndicateur._onEnregistrementValidationOuAnnulationCG(this.state.selectedReservations, onValide);

        _onEnregistrementValidationOuAnnulationCG
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    (onValide ? this._onCacheDialogValidation() : this._onCacheDialogClotureAnnulation());

                    if (objetData === '') {
                        // MG - 23/02/2022 - retirer la resa validée du state pour rechargement
                        //this.setState(prevState =>
                        //({
                        //    items: prevState.items.filter(item => 
                        //        item.idLotCommercial !== this.state.selectedReservations[0].idLotCommercial &&
                        //        item.idReservation !== this.state.selectedReservations[0].idReservation &&
                        //        item.numero !== this.state.selectedReservations[0].numero)
                        //}),
                        //    this._chargementDonnees);

                        //MG - 10/05/2022 - 1980
                        this.setState(prevState =>
                        ({
                            items: prevState.items.filter(item =>
                                !this.state.selectedReservations.find((res) =>
                                    item.idLotCommercial === res.idLotCommercial &&
                                    item.idReservation === res.idReservation &&
                                    item.numero === res.numero)
                            )
                        }),
                            this._chargementDonnees);
                    }
                    else {
                        this._onAffichageDialogRetourValidation(objetData);
                    }
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true });
    }

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    }

    _onAffichePanelDetailIndicateur = (item) => {
        this.setState({
            onAffichePanelDetailIndicateur: true,
            onPeutChargerLeComposantFicheDetailIndicateurValidation: true,
            selectedReservation: item
        });
    }

    _onCachePanelDetailIndicateur = () => {
        if (this.state.onAffichePanelDetailIndicateur) {
            this.setState({
                onAffichePanelDetailIndicateur: false,
                onPeutChargerLeComposantFicheDetailIndicateurValidation: false,
                selectedReservation: {}
            });
        }
    }

    _onAffichageDialogValidation = (items) => {
        this.setState({
            onAfficheDialogValidationCG: true,
            selectedReservations: items
        });
    }

    _onCacheDialogValidation = () => {
        this.setState({
            onAfficheDialogValidationCG: false
        });
    }

    _onAffichageDialogAnnulation = (items) => {
        this.setState({
            onAfficheDialogAnnulationValidation: true,
            selectedReservations: items
        });
    }

    _onCacheDialogClotureAnnulation = () => {
        this.setState({
            onAfficheDialogAnnulationValidation: false
        });
    }

    _onAffichageDialogRetourValidation = (message) => {
        this.setState({
            onAfficheDialogRetourValidation: true,
            messageRetourValidation: message,
            enCoursDeTraitement: false
        });
    }

    _onCacheDialogRetourValidation = () => {
        this.setState({
            onAfficheDialogRetourValidation: false
        });

        this._chargementDonnees();
    }

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            filtreMois: 0,
            filtreAnnee: 0,
            filtreNumLot: null,
            filtreResaDesisNonValidees: true,
            filtreResaDesistValidees: false
        });
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    }

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderRow = (props, defaultRender) => {

        const item = this.state.items[props.itemIndex];

        if (this._onBloqueValidation(item))
            return <DetailsRow onRenderCheck={(props) => this._onRenderCheck(props, item)} {...props} />;
        else return defaultRender(props);

    };

    // KP - 2532 - 17/11/2023 : nouvelles règles liées aux engagement initiaux et actualisés
    _onRenderCheck = (props, item) => {

        let span = null;

        const { peutValider } = this.state;
        const { cycleSignee, dateClotureCG, dateLancementCommercialisation, dateValidationCG, engagementInitialCA, engagementInitialNb, produitPrincipal, qpei, sha: engagementInitialSurface, sommeReintegrationCA, sommeReintegrationNb, sommeReintegrationSurface } = item;
        //const { dateClotureCG, dateLancementCommercialisation, dateValidationCG, engagementInitialCA, engagementInitialNb, qpei } = item;
        const dateCloture = Scriba.formulaire().nEstPasVide(dateClotureCG) ? dateClotureCG : dateValidationCG;
        const estSigneeEiffage = cycleSignee === 1;

        const estEngagementCorrect = this._estEngagementCorrect(engagementInitialCA, engagementInitialNb, engagementInitialSurface, produitPrincipal, qpei, sommeReintegrationCA, sommeReintegrationNb, sommeReintegrationSurface)

        if (!!dateCloture) span = <span className="spanDateCloture" title={`Clôturée le ${Scriba.date().stringDateFormatCourt(dateCloture)}`}>{Scriba.date().stringDateFormat(dateCloture, "MM/YY")}</span>
        else if (!estEngagementCorrect) span = <span className="spanDateCloture" title="Engagement de l'opération manquant">ENG</span>;
        else if (!dateLancementCommercialisation) span = <span className="spanDateCloture" title="Commercialisation non lancée,  merci d'indiquer une date de commercialisation réelle">COM</span>;
        else if (!estSigneeEiffage) span = <span className="spanDateCloture" title='Non Signée Eiffage - Veuillez modifier le cycle de la réservation'>NSE</span>
        else if (!peutValider) span = <span className="spanDateCloture" title="Vous n'avez pas les droits nécessaires">X</span>;

        return <div className="divCheckValidation">{span}</div>;

    };

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    }

    _onRenderFooterDetailIndicateurContent = () => {
        return (
            <div>
                <DefaultButton onClick={this._onCachePanelDetailIndicateur}>Fermer</DefaultButton>
            </div>
        );
    }

    _getClassNameDesistement(categorie) {
        return (categorie === 'Désistement' ? 'labelDesistement' : '');
    }

    _onBloqueValidation = (item) => {

        const { cycleSignee, dateClotureCG, dateLancementCommercialisation, dateValidationCG, engagementInitialCA, engagementInitialNb, produitPrincipal, qpei, sha: engagementInitialSurface, sommeReintegrationCA, sommeReintegrationNb, sommeReintegrationSurface } = item;
        const { dateDebutPeriodeOuverte, peutValider } = this.state;

        if (!peutValider) return true;
        if (!!dateClotureCG) return true; // Bloquer si dateClotureCG renseignée
        if (!dateClotureCG && !!dateValidationCG && Scriba.date().getDateFromChaineISO(dateValidationCG) <= Scriba.date().getDateFromChaineISO(dateDebutPeriodeOuverte)) return true;  // Bloquer si dateValidationCG renseignée et antérieure ou égale à dateDebutPeriodeOuverte
        if (!cycleSignee) return true; // Bloquer si non signé Eiffage
        if (!dateDebutPeriodeOuverte) return true; // Bloquer si période non ouverte
        if (!dateLancementCommercialisation) return true; // Bloquer si dateLancementCommercialisation non renseignée

        const estEngagementCorrect = this._estEngagementCorrect(engagementInitialCA, engagementInitialNb, engagementInitialSurface, produitPrincipal, qpei, sommeReintegrationCA, sommeReintegrationNb, sommeReintegrationSurface)
        if (!estEngagementCorrect) return true;

        return false;

    };

    // KP - 2532 - 17/11/2023 : nouvelles règles liées aux engagement initiaux et actualisés
    _estEngagementCorrect = (engagementInitialCA, engagementInitialNb, engagementInitialSurface, produitPrincipal, qpei, sommeReintegrationCA, sommeReintegrationNb, sommeReintegrationSurface) => {
        if ((qpei || 0) <= 0) return false; // KP - 2532 - 04/12/2023 : QPEI strictement positif
        if ((engagementInitialCA || 0) <= 0) return false;
        const engagementActualiseCA = engagementInitialCA + (sommeReintegrationCA || 0);
        if (engagementActualiseCA < 0) return false;

        if (produitPrincipal === "Tertiaire") {
            if ((engagementInitialSurface || 0) <= 0) return false;
            const engagementActualiseSurface = engagementInitialSurface + (sommeReintegrationSurface || 0);
            if (engagementActualiseSurface < 0) return false;
        }
        else {
            if ((engagementInitialNb || 0) === 0) return false;
            const engagementActualiseNb = engagementInitialNb + (sommeReintegrationNb || 0);
            if (engagementActualiseNb < 0) return false;
        }

        return true;
    };

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.filtreMois !== 0 || this.state.filtreAnnee !== 0 ? `Réservations / Désistements sur : ${Immocom.conversion().getMoisAPartirNumero(this.state.filtreMois)} ${this.state.filtreAnnee}` : ""}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        <Sticky stickyPosition={StickyPositionType.Header}>
                            <div className="labelPeriodeEnCours">{this.state.labelPeriode}</div>
                        </Sticky>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div>Réservations / Désistements sur</div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <ComboBoxMois
                                onChange={(event, option, index, value, item) => this.setState({ filtreMois: option.key })}
                                selectedKey={this.state.filtreMois}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <ComboBoxAnnee
                                onChange={(event, option, index, value, item) => this.setState({ filtreAnnee: option.key })}
                                selectedKey={this.state.filtreAnnee}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <EUITextField
                                label="Num. lot"
                                maxLength={MaxLengths.lot.numero}
                                onChange={(event, newValue) => this.setState({ filtreNumLot: event.target.value })}
                                value={this.state.filtreNumLot}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                            <Toggle
                                label="Résa./désist. non validé(e)s"
                                checked={this.state.filtreResaDesisNonValidees}
                                onText="Oui"
                                offText="Non"
                                onChange={(e, isChecked) => this.setState({ filtreResaDesisNonValidees: isChecked })}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                            <Toggle
                                label="Résa./désist. validé(e)s"
                                checked={this.state.filtreResaDesistValidees}
                                onText="Oui"
                                offText="Non"
                                onChange={(e, isChecked) => this.setState({ filtreResaDesistValidees: isChecked })}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <FicheDetailIndicateurValidation
                onAffichePanelDetailIndicateurValidation={this.state.onAffichePanelDetailIndicateur}
                idOperation={this.state.selectedReservation.idOperation}
                idReservation={this.state.selectedReservation.idReservation}
                idLotCommercial={this.state.selectedReservation.idLotCommercial}
                titre={`Détail ${this.state.selectedReservation.typeReservation === 'Réservation' ? 'de la réservation' : 'du désistement'} pour le lot n°${this.state.selectedReservation.numero}`}
                onAnnuleFiche={() => this._onCachePanelDetailIndicateur()}
                onPeutChargerLeComposant={this.state.onPeutChargerLeComposantFicheDetailIndicateurValidation}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogValidationCG}
                onDismiss={this._onCacheDialogValidation}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Valider les réservations',
                    subText: `Etes-vous certain de vouloir valider les réservations sélectionnées pour la période en cours ? ${this.state.selectedReservations.find(r => r.typeReservation === 'Désistement') !== undefined ? 'Attention, des désistements sont sélectionnés. Les réservations liées à ces désistements seront également validées. Voulez-vous continuer ?' : ''}`
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._validationDevalidationCG(true)} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogValidation} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogAnnulationValidation}
                onDismiss={this._onCacheDialogClotureAnnulation}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Annuer la validation',
                    subText: 'Etes-vous certain de vouloir annuler la validation des réservations sélectionnées ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._validationDevalidationCG(false)} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogClotureAnnulation} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogRetourValidation}
                onDismiss={this._onCacheDialogRetourValidation}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Validation / Dévalidation'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <div>{this.state.messageRetourValidation}</div>
                <DialogFooter>
                    <DefaultButton onClick={this._onCacheDialogRetourValidation} text="Fermer" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    }
}

